import i18next from 'i18next'
import { AppointmentType } from '../constants'

const appointmentTypeToDisplayText: Record<keyof typeof AppointmentType, string> = {
  [AppointmentType.AFTERCARE_FOLLOW_UP]: i18next.t('common.appointmentTypes.aftercareFollowUp'),
  [AppointmentType.EXTENDED_FOLLOW_UP]: i18next.t('common.appointmentTypes.extendedFollowUp'),
  [AppointmentType.FINAL_APPOINTMENT]: i18next.t('common.appointmentTypes.finalAppointment'),
  [AppointmentType.FOLLOW_UP]: i18next.t('common.appointmentTypes.followUp'),
  [AppointmentType.HEARING_AID_EVALUATION]: i18next.t('common.appointmentTypes.hearingAidEvaluation'),
  [AppointmentType.VIDEO_CARE_CALL]: i18next.t('common.appointmentTypes.videoCareCall'),
}

const appointmentTypeToPriority = {
  [AppointmentType.EXTENDED_FOLLOW_UP]: 3,
  [AppointmentType.FINAL_APPOINTMENT]: 6,
  [AppointmentType.FOLLOW_UP]: 2,
  [AppointmentType.HEARING_AID_EVALUATION]: 1,
  [AppointmentType.AFTERCARE_FOLLOW_UP]: 5,
  [AppointmentType.VIDEO_CARE_CALL]: 4,
}

const appointmentTypeOptions = Object.keys(appointmentTypeToDisplayText)
  .map((key) => {
    const appointmentType = key as AppointmentType
    const name = appointmentTypeToDisplayText[appointmentType]

    return {
      name,
      value: key as AppointmentType,
      priority: appointmentTypeToPriority[appointmentType],
    }
  })
  .sort((a, b) => a.priority - b.priority)

export { appointmentTypeOptions, appointmentTypeToDisplayText, appointmentTypeToPriority }
